/**
 * Firestore's AsyncQueue can enter a permanent failed state (often after an
 * IndexedDB / multi-tab persistence fault). Later operations — including the
 * SDK's own pagehide / visibilitychange cleanup — then throw:
 *   FIRESTORE (x.y.z) INTERNAL ASSERTION FAILED: Unexpected state
 * Retries cannot recover; a full page reload is required.
 */
export const isFirestoreInternalAssertionMessage = (value) => {
  const message = String(value || "");
  return (
    message.includes("FIRESTORE")
    && message.includes("INTERNAL ASSERTION FAILED")
  );
};

export const isFirestoreInternalAssertionError = (error) =>
  isFirestoreInternalAssertionMessage(error?.message || error);
